module.exports = __webpack_public_path__ + "media/images/riders/small/VERONIKA_WIDMANN-25695ce54da9db0f3d4b31438f26c767.png";